/** Fecha civil YYYY-MM-DD; arithmetic in UTC prevents DST drift. */
export function previousComparableRange(range) {
  const pattern = /^\d{4}-\d{2}-\d{2}$/;
  if (!pattern.test(range?.dateFrom || '') || !pattern.test(range?.dateTo || '')) return null;
  const start = new Date(range.dateFrom + 'T00:00:00Z');
  const end = new Date(range.dateTo + 'T00:00:00Z');
  if (Number.isNaN(start.getTime()) || Number.isNaN(end.getTime()) ||
      start.toISOString().slice(0, 10) !== range.dateFrom ||
      end.toISOString().slice(0, 10) !== range.dateTo || end < start) return null;
  const days = Math.round((end - start) / 86400000) + 1;
  return {
    since: new Date(start.getTime() - days * 86400000).toISOString().slice(0, 10),
    until: new Date(start.getTime() - 86400000).toISOString().slice(0, 10)
  };
}
